// extracted by mini-css-extract-plugin
export default {"selected":"Answers_selected__5yZT5"};